import styled from 'styled-components';
import {
  screenSize,
  whiteColor,
  regularFont,
  secondaryColor,
  appHeaderColor,
  boldFont,
} from '@app/styles';
import HeaderLogoUrl from '@app/assets/images/TransferStampLogo.svg';
import DefaultImageUrl from '@app/assets/images/user_profile.svg';
import DropDownUrl from '@app/assets/images/dropdownarrow.svg';

type ActiveProps = {
  active?: boolean;
};
type ImageProps = {
  image?: string;
  size?: string;
};
type Props = {
  show?: boolean;
  toggle?: boolean;
};
export const Container = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  @media (${screenSize.tablet}) {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`;
export const NavItems = styled.div`
  height: 100%;
  display: none;
  @media (${screenSize.tablet}) {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 30px;
    padding: 0px 10px;
    border-bottom: 2px solid ${appHeaderColor};
    ${({ active }: ActiveProps) => {
      if (active) {
        return `
         border-bottom: 2px solid #EE8C00;
        
      `;
      }
    }}
  }
`;
export const TransactionSearch = styled.div`
  height: 100%;
  display: none;
  @media (${screenSize.tablet}) {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 30px;
    padding: 0px 10px;
    border-bottom: 2px solid ${appHeaderColor};
    ${({ active }: ActiveProps) => {
      if (active) {
        return `
         border-bottom: 2px solid #EE8C00;
        
      `;
      }
    }}
  }
`;

export const MobileNavItems = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 50px;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const NavText = styled.div`
  font-size: 18px;
  display: block;
  cursor: pointer;
  color: #100f1f;
  opacity: 0.5;
  ${({ active }: ActiveProps) => {
    if (active) {
      return `
        opacity:1;

      `;
    }
  }}
  cursor:pointer;
  @media (${screenSize.tablet}) {
    opacity: 0.5;
    color: ${whiteColor};
    display: block;
    cursor: pointer;
    padding-top: 2px;
    font-size: 16px;
    ${({ active }: ActiveProps) => {
      if (active) {
        return `
         opacity:1;
        
      `;
      }
    }}
  }
`;
export const HeaderLogo = styled.div`
  height: 32px;
  width: 151px;
  background-image: url(${HeaderLogoUrl});
  background-position: 0 center;
  background-repeat: no-repeat;
  cursor: pointer;
  @media (${screenSize.tablet}) {
    height: 32px;
    width: 151px;
    margin-bottom: 2px;
  }
`;

export const NavIcon = styled.div`
  height: 19px;
  cursor: pointer;
  margin-bottom:3px;
  opacity:0.5;
  svg {
    margin-right: 7px;
    g {
      fill: #100f1f;
    }
  }
  ${({ active }: ActiveProps) => {
    if (active) {
      return `
        opacity:1;
      `;
    }
  }}
  @media (${screenSize.tablet}) {
    opacity: 0.5;
     margin-bottom:0px;
    svg {
      margin-right: 7px;
      g {
        fill: #ffffff;
      }
    }
    ${({ active }: ActiveProps) => {
      if (active) {
        return `
         opacity:1;
        
      `;
      }
    }}
  }
`;
export const NavIcon1 = styled.div`
  height: 19px;
  cursor: pointer;
  padding-top:1px;
  opacity:0.5;
  svg {
    margin-right: 7px;
    g {
      fill: #100f1f;
    }
  }
  ${({ active }: ActiveProps) => {
    if (active) {
      return `
         opacity:1;
        
      `;
    }
  }}
  @media (${screenSize.tablet}) {
    opacity: 0.5;
    padding-top:2px;
    svg {
      margin-right: 7px;
     
      g {
        fill: #ffffff;
      }
    }
    ${({ active }: ActiveProps) => {
      if (active) {
        return `
         opacity:1;
        
      `;
      }
    }}
  }
`;
export const NavContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NavBox = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
`;
export const ButtonContainer = styled.div`
  display: block;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
`;

export const MobileProfileView = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const ButtonItem = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    width: 100%;
    margin-right: 30px;
    width: 166px;
  }
`;
export const Actions = styled.div`
  ${regularFont};
  display: flex;
  align-items: center;
  .profile {
    display: flex;
    align-items: center;
  }
  @media (${screenSize.tablet}) {
    font-size: 16px;
  }
  @media (${screenSize.maxMobile}) {
    position: absolute;
    right: 15px;
  }
`;

export const Text = styled.div`
  color: ${whiteColor};
  display: none;
  cursor: pointer;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const ProfileIcon = styled.div`
  width: 30px;
  height: 30px;
  margin-left: 10px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${DefaultImageUrl});
  ${({ image, size }: ImageProps) => {
    if (image && size === 'large') {
      return `background-image:url(${image});
              width:50px;
              height:50px;`;
    } else if (image) {
      return `background-image:url(${image});`;
    } else if (size === 'large') {
      return `width:50px;
              height:50px;`;
    }
  }}
`;

export const DropDownArrow = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    height: 24px;
    width: 24px;
    margin-left: 5px;
    background-image: url(${DropDownUrl});
    background-position: 0 center;
    background-repeat: no-repeat;
    cursor: pointer;
  }
`;

export const HeaderDropDown = styled.div`
  position: fixed;
  background: ${whiteColor};
  z-index: 3;
  top: 60px;
  height: auto;
  width: 220px;
  border: 1px solid #dce0e8;
  right: 15px;
  box-shadow: 0 11px 20px 0 rgba(47, 54, 65, 0.5);
  @media (${screenSize.tablet}) {
    top: 100%;
    position: absolute;
    width: 300px;
  }
`;
export const DropDownOption = styled.div`
  font-size: 15px;
  color: #3a435e;
  height: 46px;
  display: flex;
  align-items: center;
  padding: 10px 15px 10px;
  cursor: pointer;
  svg {
    margin-right: 5px;
    g {
      fill: #80868b;
    }
  }
`;

export const SideNavOption = styled.div`
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  margin-bottom: 10px;
  cursor: pointer;
  border-bottom: 2px solid #ee8c00;
`;

export const LogoutText = styled.span`
  color: ${secondaryColor};
  font-size: 15px;
  display: flex;
  align-items: center;
  svg {
    g {
      fill: none;
    }
  }
`;

export const SearchItem = styled.div`
  width: 100%;
  cursor: pointer;
  @media (${screenSize.tablet}) {
    width: 280px;
  }
`;
export const UserDropdown = styled.div`
  position: absolute;
  top: 60px;
  width: 170px;
  background: white;
  box-shadow: 0 11px 20px 0 rgba(47, 54, 65, 0.5);
  padding: 16px 10px;
  border-radius: 8px;
`;
export const UserDropdownValue = styled.div`
  ${boldFont}
  font-size: 16px;
  line-height: 21px;
  color: #202731;
  margin-bottom: 8px;
`;
export const UserManagement = styled.div`
  display: flex;
  align-items: center;
`;
export const SideNavActions = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const CloseButton = styled.span`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 15px;
  padding-top: 15px;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const MobileSideNav = styled.div`
  position: fixed;
  background: ${whiteColor};
  z-index: 3;
  top: 60px;
  height: auto;
  width: 100%;
  border: 1px solid #dce0e8;
  right: 0;
  padding-bottom: 10px;
  padding-top: 10px;
  box-shadow: 0 11px 20px 0 rgba(47, 54, 65, 0.5);
  > div {
    &:last-child {
      border-bottom: none;
      padding-bottom: 0px;
      margin: 0;
      height: 30px;
    }
  }
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
